import { useTranslation } from 'react-i18next';
import EmptyStateMNoResultsImg from '../../../../../common/assets/images/emptystates/es-m-no-results.svg';
import { resources } from '../../../resources/resources';

export function EmptyStateNoProducts() {
  const { t: translate } = useTranslation();
  return (
    <div className="m-empty-state">
      <img src={EmptyStateMNoResultsImg} alt="No results illustration" />
      <p>{translate(resources.emptyState.noProducts)}</p>
    </div>
  );
}

export function EmptyStateNoNotifications() {
  const { t: translate } = useTranslation();
  return (
    <div className="m-empty-state">
      <img src={EmptyStateMNoResultsImg} alt="No results illustration" />
      <p>{translate(resources.emptyState.noNotifications)}</p>
    </div>
  );
}
